// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
}

    .menu > li {
        position: relative;
        margin-right: 46px;
    }

        .menu > li > span {
            padding-bottom: 30px;
        }

    .menu span {
        text-decoration: none;
        color: white;
        padding: 10px 15px;
        font-weight: 700;
        font-size: 16px;
        font-family: Barlow;
        z-index: 5;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        box-sizing: border-box;
        transition: color 0.3s ease;
    }

        .menu span::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0;
            height: 2px;
            background-color: #00d084;
            transition: width 0.3s ease;
        }

    .menu > li:hover > span::after {
        width: 100%;
    }


    .menu ul li > span {
        border-bottom: none;
        color: white;
        transform: translateY(20px);
        opacity: 0;
        transition: transform 0.3s ease-out, opacity 0.3s ease-out;
    }

    .menu > li:hover ul li > span {
        transform: translateY(0);
        opacity: 1;
    }

    .menu > li:hover ul li:nth-child(1) > span {
        transition-delay: 0.05s;
    }

    .menu > li:hover ul li:nth-child(2) > span {
        transition-delay: 0.05s;
    }

    .menu > li:hover ul li:nth-child(3) > span {
        transition-delay: 0.05s;
    }

    .menu > li:hover ul li:nth-child(4) > span {
        transition-delay: 0.05s;
    }

    .menu ul li span::after {
        display: none;
    }

    .menu > li span:hover {
        color: white;
    }

    .menu ul {
        position: absolute;
        top: 158%;
        left: 50%;
        transform: translateX(-50%);
        background-color: #00594d;
        list-style: none;
        z-index: 1;
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        pointer-events: none;
        transition: max-height 0.4s ease-out, transform 0.65s cubic-bezier(.2,.8,.25,1), opacity 0.65s cubic-bezier(.2,.8,.25,1);
        padding: 10px 15px;
        min-width: 130px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0;
    }

    .menu > li > ul:first-of-type {
        border-top: 2px solid white;
    }

    .menu li ul li {
        display: flex;
        flex-direction: column;
        flex-shrink: 1;
        box-sizing: border-box;
        padding: 8px 10px 10px 10px;
        width: inherit;
    }

    .menu ul li > span {
        border-bottom: none;
        color: white;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
    }


    .menu ul li ul {
        position: static;
        top: auto;
        left: auto;
        transform: none;
        width: 100%;
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        pointer-events: none;
        transition: max-height 0.4s ease-out, transform 0.65s cubic-bezier(.2,.8,.25,1), opacity 0.65s cubic-bezier(.2,.8,.25,1);
        background-color: transparent;
        padding: 0;
        list-style: none;
        z-index: auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .menu > li:hover ul {
        max-height: 500px;
        opacity: 1;
        pointer-events: auto;
        padding: 0px 10px;
    }
`, "",{"version":3,"sources":["webpack://./App/components/styles/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;IAEI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;QAEI;YACI,oBAAoB;QACxB;;IAEJ;QACI,qBAAqB;QACrB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,UAAU;QACV,eAAe;QACf,oCAAoC;QACpC,sBAAsB;QACtB,2BAA2B;IAC/B;;QAEI;YACI,WAAW;YACX,kBAAkB;YAClB,OAAO;YACP,SAAS;YACT,QAAQ;YACR,WAAW;YACX,yBAAyB;YACzB,2BAA2B;QAC/B;;IAEJ;QACI,WAAW;IACf;;;IAGA;QACI,mBAAmB;QACnB,YAAY;QACZ,2BAA2B;QAC3B,UAAU;QACV,0DAA0D;IAC9D;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,yBAAyB;QACzB,gBAAgB;QAChB,UAAU;QACV,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,oBAAoB;QACpB,wHAAwH;QACxH,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,iBAAiB;QACjB,2BAA2B;QAC3B,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,sBAAsB;QACtB,2BAA2B;QAC3B,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;;IAGA;QACI,gBAAgB;QAChB,SAAS;QACT,UAAU;QACV,eAAe;QACf,WAAW;QACX,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,oBAAoB;QACpB,wHAAwH;QACxH,6BAA6B;QAC7B,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,oBAAoB;QACpB,iBAAiB;IACrB","sourcesContent":[".menu {\r\n    display: flex;\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n    .menu > li {\r\n        position: relative;\r\n        margin-right: 46px;\r\n    }\r\n\r\n        .menu > li > span {\r\n            padding-bottom: 30px;\r\n        }\r\n\r\n    .menu span {\r\n        text-decoration: none;\r\n        color: white;\r\n        padding: 10px 15px;\r\n        font-weight: 700;\r\n        font-size: 16px;\r\n        font-family: Barlow;\r\n        z-index: 5;\r\n        cursor: pointer;\r\n        border-bottom: 2px solid transparent;\r\n        box-sizing: border-box;\r\n        transition: color 0.3s ease;\r\n    }\r\n\r\n        .menu span::after {\r\n            content: '';\r\n            position: absolute;\r\n            left: 0;\r\n            bottom: 0;\r\n            width: 0;\r\n            height: 2px;\r\n            background-color: #00d084;\r\n            transition: width 0.3s ease;\r\n        }\r\n\r\n    .menu > li:hover > span::after {\r\n        width: 100%;\r\n    }\r\n\r\n\r\n    .menu ul li > span {\r\n        border-bottom: none;\r\n        color: white;\r\n        transform: translateY(20px);\r\n        opacity: 0;\r\n        transition: transform 0.3s ease-out, opacity 0.3s ease-out;\r\n    }\r\n\r\n    .menu > li:hover ul li > span {\r\n        transform: translateY(0);\r\n        opacity: 1;\r\n    }\r\n\r\n    .menu > li:hover ul li:nth-child(1) > span {\r\n        transition-delay: 0.05s;\r\n    }\r\n\r\n    .menu > li:hover ul li:nth-child(2) > span {\r\n        transition-delay: 0.05s;\r\n    }\r\n\r\n    .menu > li:hover ul li:nth-child(3) > span {\r\n        transition-delay: 0.05s;\r\n    }\r\n\r\n    .menu > li:hover ul li:nth-child(4) > span {\r\n        transition-delay: 0.05s;\r\n    }\r\n\r\n    .menu ul li span::after {\r\n        display: none;\r\n    }\r\n\r\n    .menu > li span:hover {\r\n        color: white;\r\n    }\r\n\r\n    .menu ul {\r\n        position: absolute;\r\n        top: 158%;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        background-color: #00594d;\r\n        list-style: none;\r\n        z-index: 1;\r\n        max-height: 0;\r\n        opacity: 0;\r\n        overflow: hidden;\r\n        pointer-events: none;\r\n        transition: max-height 0.4s ease-out, transform 0.65s cubic-bezier(.2,.8,.25,1), opacity 0.65s cubic-bezier(.2,.8,.25,1);\r\n        padding: 10px 15px;\r\n        min-width: 130px;\r\n        display: flex;\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        padding: 0;\r\n    }\r\n\r\n    .menu > li > ul:first-of-type {\r\n        border-top: 2px solid white;\r\n    }\r\n\r\n    .menu li ul li {\r\n        display: flex;\r\n        flex-direction: column;\r\n        flex-shrink: 1;\r\n        box-sizing: border-box;\r\n        padding: 8px 10px 10px 10px;\r\n        width: inherit;\r\n    }\r\n\r\n    .menu ul li > span {\r\n        border-bottom: none;\r\n        color: white;\r\n        font-weight: 700;\r\n        text-align: center;\r\n        white-space: nowrap;\r\n    }\r\n\r\n\r\n    .menu ul li ul {\r\n        position: static;\r\n        top: auto;\r\n        left: auto;\r\n        transform: none;\r\n        width: 100%;\r\n        max-height: 0;\r\n        opacity: 0;\r\n        overflow: hidden;\r\n        pointer-events: none;\r\n        transition: max-height 0.4s ease-out, transform 0.65s cubic-bezier(.2,.8,.25,1), opacity 0.65s cubic-bezier(.2,.8,.25,1);\r\n        background-color: transparent;\r\n        padding: 0;\r\n        list-style: none;\r\n        z-index: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .menu > li:hover ul {\r\n        max-height: 500px;\r\n        opacity: 1;\r\n        pointer-events: auto;\r\n        padding: 0px 10px;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
